import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inputRoot: {
    color: theme.palette.text.primary,
    background: theme.palette.background.paper,
    borderRadius: '3px',
    width: '35px',
    marginLeft: 5,
    paddingLeft: 5,
    paddingRight: 5,
  },
  inputInput: {
    transition: theme.transitions.create('width'),
    width: '50%',
    color: theme.palette.text.primary,
    fontSize: 14,

    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
  paginationWrapper: {
    [theme.breakpoints.down('lg')]: {
      //flexDirection: 'column',
    },
  },
}));
